import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";

const viewAssessmentReport = (userGUID, assessmentAttemptId, locale) => {
  return function () {
    return AssessmentServiceApi.viewAssessmentReport(
      userGUID,
      assessmentAttemptId,
      locale
    )
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

export { viewAssessmentReport };
